var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"69b11cd12cb4d46732bdfd894afe64d26fff17d5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import config from 'config';

const isWidgetPage = window.location.pathname.includes('/widgets');
const tracesSampleRateValue = isWidgetPage ? 0 : 0.1;
if (config.get('public.sentry.enabled')) {
  Sentry.init({
    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true,
      }),
    ],
    dsn: config.get('public.sentry.dsn'),
    // Adjust this value in production, or use tracesSampler for greater control
    // https://develop.sentry.dev/sdk/performance/#tracessamplerate
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/sampling/#setting-a-uniform-sample-rate
    tracesSampleRate: tracesSampleRateValue,

    denyUrls: [
      // Block transactions and errors on widget pages
      /^(.*?(\*?.fixter.co.uk\/widgets)[^$]*)$/,
      /^(.*?(\*?.fixter.fr\/widgets)[^$]*)$/,
      // Block Microsoft Bat script errors
      'https://bat.bing.com/bat.js',
    ],
    ignoreErrors: [
      'cookieconsent',
      'widget',
      'GraphQL error: getSession',
      '_submitInjector',
      'HTMLScriptElement.t.onload',
      'chunks/pages/_app',
      // Ignore all widget-related errors
      /widgets/,
    ],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    environment: config.get('public.environment'),
  });
}
